module.exports = __webpack_public_path__ + "img/404.8211fb5d.svg";